<script lang="ts">
	import type { Salary } from "../../types/types";

	/**
	 * The salary object containing either a single value or a range of values.
	 * - If `value` is present, it represents a fixed salary.
	 * - If `minValue` and `maxValue` are present, they represent a salary range.
	 * @type {Salary}
	 */
	export let salary: Salary;

	/**
	 * Formats a number using Dutch locale formatting.
	 * @param {number | undefined} value - The number to format.
	 * @returns {string} The formatted number as a string.
	 */
	function formatNumber(value?: number) {
		if (value === undefined || value === null) {
			return "0";
		}
		return Intl.NumberFormat("nl-NL", {
			maximumFractionDigits: 3
		}).format(value);
	}
</script>

{#if salary?.value?.value}
	€{formatNumber(salary.value.value)}
{:else}
	€{formatNumber(salary?.value?.minValue)} - €{formatNumber(
		salary?.value?.maxValue
	)}
{/if}
